import {
  React,
  useState
} from "react"


import Calendario from './Calendario';
import Desafio from './Desafio';
import DesafioFinal from './DesafioFinal';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function DesafioNatal() {

  const [dia, setDia] = useState(0);
  const [showDesafioRespondido, setShowDesafioRespondido] = useState(false);

  const [desafioNaoDisponivelMessage, setDesafioNaoDisponivelMessage] = useState("");
  const [showDesafioNaoDisponivel, setShowDesafioNaoDisponivel] = useState(false);


  let sessionId = localStorage.getItem("sessionId")
  if (sessionId !== null) {
    fetch("https://www.araquelexplica-te.pt/custom/natal2022/score.php?sessionId=" + sessionId,
    //fetch("http://127.0.0.1:8000/score.php?sessionId=" + sessionId,
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      })
      .then(
        res => res.json()
      ).then(
        result => {
          for (var i = 0; i < result.result.length; i++) {
            let resposta = result.result[i];
            var resposta_certa = ""
            console.log(resposta.resposta_certa )
            if (resposta.resposta_certa === 1) {
              resposta_certa = "correcto"
            } else {
              resposta_certa = "errado"
            }
            localStorage.setItem("desafio" + resposta.desafio, resposta_certa)
          }
        }
      )

  }



  const handleClose = () => {
    setShowDesafioRespondido(false);
  }

  const handleCloseDesafioNaoDisponivel = () => {
    setShowDesafioNaoDisponivel(false);
  }

  function isDesafioCompleto() {
    for (let i = 1; i < 25; i++) {
      if (localStorage.getItem("desafio" + i) === null) {
        return false;
      }
    }
    return true;
  }




  const handleDia = (diaValue) => {
    var date = new Date();

    let dataDesafio = new Date("12/" + diaValue + "/2022").getTime();
    let hoje = date.getTime();

     if (dataDesafio > hoje) {
       setDesafioNaoDisponivelMessage("Este desafio ainda não está disponível. Volta no dia " + diaValue + " de dezembro para resolveres este desafio.");
       setShowDesafioNaoDisponivel(true);
       return;
     }

    if (localStorage.getItem("desafio" + diaValue) === null) {
       if (diaValue === "25" && !isDesafioCompleto()) {
         setDesafioNaoDisponivelMessage("Ainda não completaste os desafios anteriores. Tens de completar os 24 desafios para poderes abrir o dia 25.")
         setShowDesafioNaoDisponivel(true);
         return;
       }
      setDia(diaValue);
    }else if(diaValue === "25"){
      setDia(diaValue);
    } else {
      setShowDesafioRespondido(true);
    }

  }

  const returnToCalendar = () => {
    setDia(0);
  }

  return (
    <div>
      <div class="text-center mt-5">
        <div class="text-center">
          {(dia == 0) ? (<Calendario handleDia={handleDia} />) : (
            (dia == 25) ? (<DesafioFinal dia={dia} returnToCalendar={returnToCalendar} />) : (<Desafio dia={dia} returnToCalendar={returnToCalendar} />)
          )}
        </div>
      </div>


      <Modal
        show={showDesafioRespondido}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Desafio respondido</Modal.Title>
        </Modal.Header>
        <Modal.Body>Já respondeste a este desafio.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>



      <Modal
        show={showDesafioNaoDisponivel}
        onHide={handleCloseDesafioNaoDisponivel}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Desafio não disponível</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {desafioNaoDisponivelMessage}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleCloseDesafioNaoDisponivel}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>



    </div>
  )
}

export default DesafioNatal